(function () {
  var DAY_MS = 86400000;

  function parseLocalEndOfDay(value) {
    if (!value) return null;
    var parts = String(value).split("-").map(function (part) {
      return parseInt(part, 10);
    });

    if (parts.length !== 3 || parts.some(isNaN)) return null;

    return new Date(parts[0], parts[1] - 1, parts[2], 23, 59, 59);
  }

  function labelForDays(daysLeft) {
    if (daysLeft >= 2) return "Ends in " + daysLeft + " days";
    if (daysLeft === 1) return "Ends tomorrow";
    return "Ends today";
  }

  function refreshCard(card) {
    var mode = card.getAttribute("data-badge-mode");
    var badge = card.querySelector("[data-mas-spot-badge]");
    var label = card.querySelector("[data-mas-spot-label]");
    var hideExpired = card.getAttribute("data-hide-expired") === "true";

    if (mode !== "countdown" || !badge || !label) return false;

    var end = parseLocalEndOfDay(card.getAttribute("data-end-date"));
    if (!end) return false;

    var daysLeft = Math.ceil((end.getTime() - Date.now()) / DAY_MS);

    if (daysLeft < 0) {
      if (hideExpired) {
        card.hidden = true;
        card.style.display = "none";
        return true;
      }

      badge.hidden = true;
      return false;
    }

    label.textContent = labelForDays(daysLeft);
    badge.hidden = false;
    card.hidden = false;
    card.style.display = "";
    return false;
  }

  function refreshSection(section) {
    var cards = Array.prototype.slice.call(section.querySelectorAll("[data-mas-spot-card]"));
    if (!cards.length) return;

    var hiddenCount = cards.reduce(function (count, card) {
      return count + (refreshCard(card) ? 1 : 0);
    }, 0);

    if (hiddenCount === cards.length) {
      section.hidden = true;
    }
  }

  function refreshAll() {
    document.querySelectorAll("[data-mas-spot-section]").forEach(refreshSection);
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".mas-spot__cta-link")) {
      event.stopPropagation();
    }
  });

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", refreshAll);
  } else {
    refreshAll();
  }

  window.setInterval(refreshAll, 60 * 60 * 1000);
})();
